import React from "react";
import CheckAuthQuery from "theme/modules/Router/CheckAuthQuery.gql";
import useCallbackModal from "theme/components/helpers/useModalCallback";
import LoginModal from "./LoginModal";
import { useApolloClient } from "react-apollo";

const useEnsureLoggedInPromise = ({ message }) => {
  const client = useApolloClient();
  const { isOpen, onRequestClose, onSuccess, openCallbackModal } =
    useCallbackModal();

  const isLoggedIn = () => {
    return client.query({ query: CheckAuthQuery }).then((response) => {
      return response.data && response.data.me && response.data.me.id;
    });
  };

  const ensureLoggedIn = () => {
    return isLoggedIn().then((isLoggedIn) => {
      if (isLoggedIn) {
        return Promise.resolve(true);
      } else {
        return openCallbackModal().then(() => false);
      }
    });
  };

  return {
    modal: isOpen ? (
      <LoginModal
        message={message}
        isOpen={isOpen}
        onRequestClose={onRequestClose}
        onLoginSuccess={onSuccess}
      />
    ) : null,
    ensureLoggedIn,
  };
};

export default useEnsureLoggedInPromise;
